export interface OrderTemplate {
  value: string;
  label: string;
  schema: any;
}

const stripOrderSuffix = (title: string): string =>
  title.replace(/\s+Order$/i, "").trim();

const context: any = (require as any).context("./", false, /\.json$/);

export const orderTemplates: OrderTemplate[] = context
  .keys()
  .map((key: string) => context(key))
  .filter((schema: any) => schema && typeof schema.type === "string")
  .map((schema: any) => ({
    value: schema.type,
    label: stripOrderSuffix(schema.title || schema.type),
    schema,
  }))
  .sort((a: OrderTemplate, b: OrderTemplate) => a.label.localeCompare(b.label));

export const schemaMap: Record<string, any> = Object.fromEntries(
  orderTemplates.map((t) => [t.value, t.schema])
);
